// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCqsuXR7r-OllrBzbzGcvnZTcsGNuHRI2w",
  authDomain: "store-49d01.firebaseapp.com",
  projectId: "store-49d01",
  storageBucket: "store-49d01.firebasestorage.app",
  messagingSenderId: "861764129316",
  appId: "1:861764129316:web:2ab305c1145ffdfd51beb1",
  measurementId: "G-CE1S1HYR0S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// أضف هذا السطر لتصدير db
export const db = getFirestore(app);